import React, { useState } from "react";
import InflueCard from "../../tools/InflueCard";
import { Plus, Search } from "lucide-react";

import MyDropList2 from "../../tools/MyDropList2";

export default function Influencer() {
  const [sortBy, setSortBy] = useState('network');
  return (
    <div className="space-y-2 flex flex-col ">
      {/* topBar */}
      <div className="flex py-2 items-center gap-3 w-full">
        <span className="text-slate-800 dark:text-slate-100 font-semibold text-lg tracking-wider whitespace-nowrap ">
          All Influencer
        </span>
        {/* search */}
        <div className="my-4 px-4 relative w-full md:w-80">
          <Search
            size={16}
            className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-500"
          />
          <input
            type="search"
            placeholder="Search by name or tag..."
            //   value={search}
            // onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                //  setPage(1);
                //setAppliedSearch(search.trim());
              }
            }}
            className="w-full ps-8 md:w-80 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          />
        </div>
        {/* sort by */}
        <MyDropList2
          label={"sort by"}
          options={[
            { label: "Network", value: "network" },
            { label: "Name", value: "name" },
          ]}
          className="w-70 text-slate-100 ml-auto flex items-center"
          value={sortBy}
          onChange={(tab) => {
            setSortBy(tab.value);
          }}
        />
        {/* add button */}
        <button
          type="button"
          className="
                     flex items-center justify-center
                     h-9 w-9
                     rounded-md
                   bg-blue-600 hover:bg-blue-700
                   text-white
                     shadow-sm
                       transition-all duration-200
                        hover:scale-105
                       active:scale-95
                     focus:outline-none
                    focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                  dark:ring-offset-slate-900
  "
        >
          <Plus size={16} strokeWidth={2.5} />
        </button>
      </div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
        <InflueCard />
        <InflueCard />
        <InflueCard />
        <InflueCard /> <InflueCard />
        <InflueCard />
        <InflueCard />
        <InflueCard />
      </div>
    </div>
  );
}
